import { createFileRoute } from '@tanstack/react-router';
import { DescribePage } from '@/features/debrief-v2';

export const Route = createFileRoute(
  '/_dashboard/interactions/debrief-v2/$id/describe'
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <DescribePage sessionId={id} />;
}
